import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3542f0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "declared-value form-item-cell" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "保价金额"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, " Declared Value ")
], -1))
const _hoisted_3 = { class: "declare-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-prefix" }, "¥", -1))
const _hoisted_5 = {
  key: 0,
  class: "declare-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "g-input g-input__placeholder",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.declareAmount) = $event)),
        "placeholder-class": "g-input__placeholder",
        placeholder: "填写包裹价值（RMB），用于保价。",
        type: "number"
      }, null, 512), [
        [_vModelText, _ctx.form.declareAmount]
      ]),
      _createVNode(_component_Icon, {
        onClick: _ctx.showDeclareTips,
        class: "declare-explanation",
        icon: "btn_explanation"
      }, null, 8, ["onClick"])
    ]),
    (_ctx.isShowTip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 当前保价金额已超过平台最高 100 元的赔付标准，需加收 3% 的保价费。 "))
      : _createCommentVNode("", true)
  ]))
}